// @flow
import React, { Component, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { RouteUtil } from 'utils/RouteUtil';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { Container, Nav } from 'react-bootstrap';
import { FormatHeader } from 'components/atoms/formatHeader';
import { GetInTouch } from 'components/atoms/getInTouchButton';
import { GetInTouchModal } from 'components/templates/getInTouchModal';
import { ApplyForJobButton } from 'components/organisms/applyForJobButton';
import { RestaurantActions } from 'modules/restaurant/actions';
import RestaurantMobileMenuModal from 'components/templates/restaurantMenuModal';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { OverlayModal } from 'components/templates/overlayModal';
import { RouteNames } from 'router';

import down from 'assets/images/Icons_menu-down-arrow.svg';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  onClick: () => void,
  icon: Component<*>,
};

const MobileHeader = (props: Props) => {
  const {
    type,
    icon,
    onClick,
    showModal,
    headerItem,
    headerArtistButton,
    toggleModal,
    breadcrumbList,
    textDecoration,
    showGetInTouch = false,
    campaignCode,
    salesEmail,
    checkForCTAButton = true,
    onGetInTouchClick = true,
    projectInterested,
    roleName,
    showApplyNow = false,
  } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [options, showOptions] = useState(false);

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const onProjectAnnouncementClick = urlSlug => {
    const redirectionURl = urlSlug;
    if (redirectionURl) {
      const matches =
        redirectionURl.includes('https') ||
        redirectionURl.includes('http') ||
        redirectionURl.toUpperCase().includes('https') ||
        redirectionURl.toLowerCase().includes('https');
      if (!matches) {
        RouteUtil.setRouteChange(props, redirectionURl);
      } else {
        window.location.assign(`${redirectionURl}`);
      }
    }
  };

  const checkAnnouncementURL = urlSlug => {
    if (checkForCTAButton === true && !urlSlug) onGetInTouchClick(true);
    else onProjectAnnouncementClick(urlSlug);
  };
  const showOverlay = options ? (
    <OverlayPortal>
      <OverlayModal
        data={headerItem}
        theme={'transparent'}
        type={'restaurant-header-buttons'}
        onClosePress={() => showOptions(false)}
        breadcrumbList={[]}
      />
    </OverlayPortal>
  ) : null;

  return (
    <div className={`header-section`}>
      <div className={'menu-icon-container'}>
        <a onClick={onClick} className={'menu-icon'}>
          {icon}
        </a>
      </div>
      <div className={'logo-container'}>
        {breadcrumbList &&
          breadcrumbList[0] &&
          breadcrumbList[0].breadcrumbName && (
            <Breadcrumb>
              <Breadcrumb.Item
                onClick={() =>
                  breadcrumbList
                    ? RouteUtil.setRouteChange(
                        props,
                        breadcrumbList[0].breadcrumbLink
                      )
                    : '/'
                }
                // href={breadcrumbList ? breadcrumbList[0].breadcrumbLink : '/'}
              >
                <FormatHeader
                  textDecoration={textDecoration}
                  breadcrumbText={
                    breadcrumbList
                      ? breadcrumbList[0].breadcrumbName
                      : 'TotalEnvironment'
                  }
                />
              </Breadcrumb.Item>
            </Breadcrumb>
          )}
        {showGetInTouch && (
          <GetInTouch
            buttonName={'GET IN TOUCH'}
            onClick={() => setIsModalOpen(true)}
          />
        )}
        {showApplyNow && (
          <ApplyForJobButton
            mode={'dark'}
            className={'apply-button'}
            roleName={roleName}
          />
        )}

        {type == 'artistHeader' && 
          <Container>
            <Nav className="me-auto">
              {headerArtistButton.map(data => {
                return (
                  <Nav.Link  onClick={() =>
                    checkAnnouncementURL(
                      data.artistIntro.artist_button_link
                    )
                  }>
                    {data.artistIntro.artist_button_name}
                  </Nav.Link>
                );
              })}
            </Nav>
          </Container>
        }
        {type === 'restaurant' && headerItem && (
          <>
            <div
              className={'restaurant-header-button'}
              // onClick={() => toggleModal(true)}
              onClick={() => showOptions(true)}
            >
              <img src={down} alt={'open-menu'} />
            </div>
            <RestaurantMobileMenuModal
              isOpen={showModal}
              modalContent={headerItem}
            />
            {showOverlay}
          </>
        )}
        {type === 'campaign' && headerItem}
        <GetInTouchModal
          isOpen={isModalOpen}
          onClosePress={closeModal}
          campaignCode={campaignCode}
          salesEmail={salesEmail}
          callPostLeadAPI={true}
          projectInterested={projectInterested}
        />
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    showModal: state.restaurant.closeModal,
  };
};

const mapDispatchToProps = dispatch => {
  const { toggleModal } = RestaurantActions;
  return bindActionCreators(
    {
      toggleModal,
    },
    dispatch
  );
};

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(MobileHeader);

export default withRouter(connectedComponent);
